var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('navbar',{staticClass:"nav"}),_c('intro'),_c('definicao',{attrs:{"id":"definicao"}}),_c('compartilhe',{staticClass:"mb-5"}),_c('beneficios',{attrs:{"id":"beneficios"}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }